export const environment = {
	production: false,
	mapbox: {
		accessToken:
			"pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY2xidjhnbGV2MXlmZTNvbzkxNDgzamczcCJ9._3eukN1cI_LhCDOp40qRkQ", // Your access token goes here
	},
	// We can create other properties for any other tokens we need
};
